module.exports = __webpack_public_path__ + "static/img/bzBanner.0c761296.png";